export const FOCUS_ANCHORS = {
  SERVICE_SELECT: 'serviceSelect',
} as const
